import {
  MembershipDependentIdentityDocumentType,
  PaymentMethod,
} from "@/services/core-api-adapter";
import ConsultationOrderSummary from ".";

export default function ConsultationOrderSummaryExamples() {
  const commonProps = {
    consultationPaymentReceipt: {
      paymentSuccess: true,
      status: "PAYMENT_SUCCEEDED",
      paymentUtcDateTime: "2025-02-13T12:26:39.825417+00:00",
      paymentAmount: 42800,
      originalAmount: 0,
      discountAmount: 0,
      isDiscountApplied: false,
      currencyCode: "ZAR",
      transactionReferenceNumber: "MR3998254137",
      unuMerchantId: "3d1d80d3-68c6-44b3-b3b8-9b30efc493fb",
      cardNumber: "45485813******70",
      voucherName: null,
      voucherCode: null,
      paymentMethod: PaymentMethod.CardNotPresent,
      oneVoucherDetails: null,
      hasDoneServiceRating: false,
      patientMemberId: "",
      discountVoucherDetails: null,
    },
    consultationId: "8b2b69ac-7e85-44eb-90b8-1d6cd5565eb0",
    redirectToSupportUrl: "https://support.example.com",
    onViewReceiptClick: () => console.log("View Receipt Clicked"),
    onBackButtonClick: () => console.log("Back Clicked"),
    onRateService: () => console.log("Rate Service Clicked"),
    selectedDependant: {
      memberId: "dd9def3e-cefc-4e6b-8777-da863dae0be6",
      firstName: "Joe",
      lastName: "Persona",
      identityDocumentType: MembershipDependentIdentityDocumentType.ID_NUMBER,
      identityDocumentValue: "1301010465087",
      sexAtBirth: "Male",
      dateOfBirth: "2013-01-01",
      identityDocumentCountryOfIssue: "ZAF",
    },
  };

  return (
    <>
      <ConsultationOrderSummary
        {...commonProps}
        consultationPaymentReceipt={{
          ...commonProps.consultationPaymentReceipt,
          chargeCode: "ONLINE_DOCTOR_CONSULTATION",
        }}
      />
      <ConsultationOrderSummary
        {...commonProps}
        consultationPaymentReceipt={{
          ...commonProps.consultationPaymentReceipt,
          chargeCode: "DIGITAL_DOCTOR_CONSULT",
        }}
      />
      <ConsultationOrderSummary
        {...commonProps}
        consultationPaymentReceipt={{
          ...commonProps.consultationPaymentReceipt,
          chargeCode: "DIGITAL_DOCTOR_CONSULT",
          voucherName: "CareCard Voucher",
          voucherCode: "CCV123456789",
          paymentMethod: PaymentMethod.CareCardVoucher,
        }}
      />
      <ConsultationOrderSummary
        {...commonProps}
        consultationPaymentReceipt={{
          ...commonProps.consultationPaymentReceipt,
          chargeCode: "DIGITAL_DOCTOR_CONSULT",
          voucherName: "CareCard Voucher",
          voucherCode: "CCV123456789",
          paymentMethod: PaymentMethod.CareCardVoucher,
          hasDoneServiceRating: true,
        }}
      />
    </>
  );
}
